
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MetaTags from "@/components/MetaTags";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { LinkedinIcon, MailIcon, FileText } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const About = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <MetaTags
        title="About Bharathi priyaa Thangamani | HelloML"
        description="Meet Bharathi priyaa Thangamani, ML engineer and coach at HelloML. Expert in machine learning system design and interview preparation."
      />
      <Navbar />

      <main className="flex-grow">
        <section className="py-16 md:py-24">
          <div className="container">
            <div className="grid md:grid-cols-3 gap-12 items-start">
              {/* Profile Section */}
              <div className="md:col-span-1">
                <div className="sticky top-24">
                  <div className="flex flex-col items-center text-center">
                    <Avatar className="h-48 w-48 mb-6">
                      <AvatarImage src="/lovable-uploads/532b9985-1d36-41e2-90f5-aaafcc0aeaa5.png" alt="Bharathi priyaa Thangamani" />
                      <AvatarFallback>BT</AvatarFallback>
                    </Avatar>
                    <h1 className="text-3xl font-bold mb-2">Bharathi priyaa Thangamani</h1>
                    <p className="text-muted-foreground mb-4">ML Engineer & Interview Coach</p>
                    
                    <div className="flex gap-3 mb-6">
                      <a
                        href="https://www.linkedin.com/in/bharathipriyaa/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Button variant="outline" size="icon">
                          <LinkedinIcon className="h-5 w-5" />
                        </Button>
                      </a>
                      <a href="mailto:contact@helloml.org">
                        <Button variant="outline" size="icon">
                          <MailIcon className="h-5 w-5" />
                        </Button>
                      </a>
                    </div>

                    <div className="space-y-3 w-full">
                      <Button className="w-full" asChild>
                        <Link to="/coaching">Book a Coaching Session</Link>
                      </Button>
                      <Button variant="outline" className="w-full" asChild>
                        <a
                          href="https://prepfully.com/coaches/K4RRVK"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Coach Profile
                        </a>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bio and Details */}
              <div className="md:col-span-2">
                <h2 className="text-2xl font-bold mb-4">About Me</h2>
                <Card className="mb-8">
                  <CardContent className="pt-6 prose max-w-none">
                    <p>
                      I'm a passionate Machine Learning Engineer currently at Airbnb, with over 8 years of experience building large-scale ML systems across top tech companies.
                    </p>
                    <p>
                      At Roblox, I led the Homepage Cold-Start User Recommendation Pod, owning both retrieval and ranking models. My work included authoring Two-Tower architectures, migrating models from TensorFlow to PyTorch, and experimenting with Transformer-based user behavior models.
                    </p>
                    <p>
                      During my time at Instagram (2020–2023), I served as Tech Lead for the New Surface Ads workstream, improving recommendation quality on Reels and Feed. I also led the Related Ads team, launching new engagement-focused ad products that contributed to revenue growth.
                    </p>
                    <p>
                      I began my ML career at Facebook (2017–2020), where I worked on hoax detection models using GBDTs and built classifiers to detect disbelief in user comments. I later led the Election Misinformation ML Pod, developing proactive detection systems for election-related hoaxes across multiple countries using transfer learning and multilingual techniques.
                    </p>
                    <p>
                      I hold a Master's degree in Computer Science from the NYU Courant Institute, specializing in Machine Learning and Artificial Intelligence.
                    </p>
                  </CardContent>
                </Card>

                <h2 className="text-2xl font-bold mb-4">Why did I create helloml.co</h2>
                <Card className="mb-8">
                  <CardContent className="pt-6 prose max-w-none">
                    <p>
                      Over the past few years, I've had the chance to mentor candidates preparing for system design interviews through platforms like Prepfully and Medium. That experience sparked a deeper passion-for mentoring, writing, and diving into machine learning discussions, especially with senior engineers.
                    </p>
                    <p>
                      I created HelloML.co to continue that journey in a more focused and professional space-a place to share frameworks, insights, and practical guidance for ML system design.
                    </p>
                    <p>
                      Thanks for stopping by-I hope you find the content helpful and worth your time.
                    </p>
                    <p>
                      I hope you find the content helpful! If you have suggestions or feedback on how I can make HelloML.co better, feel free to drop me a note at hellomle25@gmail.com - I'd love to hear from you.
                    </p>
                  </CardContent>
                </Card>

                <h2 className="text-2xl font-bold mb-4">Ready to improve your ML interview skills?</h2>
                <div className="flex flex-col sm:flex-row gap-4 mb-8">
                  <Button className="flex-1" asChild>
                    <Link to="/get-premium">Get Premium Resources</Link>
                  </Button>
                  <Button variant="outline" className="flex-1" asChild>
                    <Link to="/coaching">Schedule Coaching</Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default About;
